import React, { useState, useContext } from 'react';
import noteContext from './Context/NoteContext';
export default function InputForm() {

    const {
        expenseList, setExpenseList,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        edittmp, setedittmp,
        ind, setind,
        allCat, setAllCat,
        addExpense, deleteExpense, updateExpense,
        openModal, closeModal, setmodalTypeAndOpen
    } = useContext(noteContext);

    const SubmitHandle = async (e) => {
        e.preventDefault()
        const inputData = new FormData(e.target)
        const newItem = Object.fromEntries(inputData.entries());
        const Transction = {
            amount: newItem.inpValue,
            type: newItem.type,
            description: newItem.description,
            date: newItem.date,
            category: categories
        }

        const type = inputData.get("type")
        setExpenseList(prev => [...prev, Transction])
        e.target.reset()
        setCategories({});
        tempSet("")
    }
    /* Input fields submit */

    /* modal Handle */
    const modalHandle = () => {
        setModalType("category")
    }
    /* modal Handle */

    const [temp, tempSet] = useState("");
    const [Total, setTotal] = useState(0);

    return (
        <div>
            {/*Input Form */}

            <form className="input" onSubmit={SubmitHandle}>
                <label htmlFor='InputField'></label>
                <input type="number" placeholder='Amount' name="inpValue" id="inpValue" value={temp} onChange={(e) => tempSet(e.target.value)}/>
                <div className="Radio">
                    <div className="Radioeach">
                        <label htmlFor="Expense">Expense</label>
                        <input type="radio" name="type" value="Expense" id="Expense" required />
                    </div>
                    <div className="Radioeach">
                        <label htmlFor="Income">Income</label>
                        <input type="radio" name="type" value="Income" id="Income" required />
                    </div>
                    <input maxLength={40} placeholder='Description' name="description" type="text" id="description" />
                    <input type="date" name="date" defaultValue={new Date().toISOString().split("T")[0]} />
                    <button type="submit" disabled={temp.length === 0 || !categories.name} >Submit</button>
                    <label htmlFor="catagory" />
                    <button type="button" onClick={modalHandle}>Select Category</button><div>{categories.name}{categories.icon}</div>
                </div>
            </form>
            <div className="Total Asset">
            </div>
            {/*Input Form */}

        </div>


    )
}


